export default __webpack_public_path__ + "static/media/UberEats.1452f9a7.png";